import styled from '@emotion/styled'

export const Wrapper = styled.div`
  width: 18px;
  height: 18px;
  cursor: pointer;
`
